export default __webpack_public_path__ + "static/media/4.404f1146.jpeg";